import { z } from 'zod';
import { UserSummary } from './admin';
import { IsoDate, PaginationQuery, paginated } from './common';

/** Journal d'audit (`data-model.md` § `audit_log`) : `GET /audit` (admin), paginé, plus récent d'abord. */

export const AuditQuery = PaginationQuery.extend({
  action: z.string().trim().min(1).max(80).optional(),
  actorId: z.string().min(1).optional(),
  entityType: z.string().trim().min(1).max(40).optional(),
});
export type AuditQuery = z.infer<typeof AuditQuery>;

export const AuditLogRow = z.object({
  id: z.number().int(),
  /** `null` pour le bootstrap et les actions système. */
  actor: UserSummary.nullable(),
  action: z.string(),
  entityType: z.string(),
  entityId: z.string().nullable(),
  data: z.record(z.string(), z.unknown()),
  createdAt: IsoDate,
});
export type AuditLogRow = z.infer<typeof AuditLogRow>;

export const AuditResponse = paginated(AuditLogRow);
export type AuditResponse = z.infer<typeof AuditResponse>;
